import { render, staticRenderFns } from "./MyDocuments.vue?vue&type=template&id=b59edbe2&scoped=true"
import script from "./MyDocuments.vue?vue&type=script&lang=ts"
export * from "./MyDocuments.vue?vue&type=script&lang=ts"
import style0 from "./MyDocuments.vue?vue&type=style&index=0&id=b59edbe2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59edbe2",
  null
  
)

export default component.exports